
//Sidenote: all functions must not contain "sessionStorage" bc class is names like this

export interface ISessionStorageService{
	getData: (storageName: string) => any;
	storeOrReplaceData: (storageName: string, data: any) => void;
	clearSessionStorage: () => void;
	getAllKeys: () => string[];
	removeWithStorageName: (storageName: string) => void;
}

class SessionStorageService implements ISessionStorageService {
    public getData = (storageName: string) => {
		const sotrageData = sessionStorage.getItem(storageName);
		const data = JSON.parse(sotrageData!);
	
		return data;
	};
	
	public storeOrReplaceData = (storageName: string, data: any) => {
		const dataExists = this.getData(storageName)
		if(dataExists)
			this.removeWithStorageName(storageName)

		sessionStorage.setItem(storageName, JSON.stringify(data));
	};

	public removeWithStorageName = (storageName: string) => {
		sessionStorage.removeItem(storageName);
	}

	public getAllKeys = () => {
		return Object.keys(sessionStorage);
	}

	public clearSessionStorage = () => {
		sessionStorage.clear();
	};
}

export { SessionStorageService };